<template>
  <div style="height: 100%; background-color: #fff; padding-top: 30px">
    <a-row class="basic_row">
      <a-col :span="10" class="basic_title">编辑在线办公系统名称：</a-col>
      <a-col :span="14" class="basic_input">
        <a-input
          placeholder="请输入"
          class="input"
          v-model="basicInfo.editSystemName"
        />
      </a-col>
    </a-row>
    <a-row class="basic_row">
      <a-col :span="10" class="basic_title">作者在线投稿系统名称：</a-col>
      <a-col :span="14" class="basic_input">
        <a-input
          placeholder="请输入"
          class="input"
          v-model="basicInfo.authorSystemName"
        />
      </a-col>
    </a-row>
    <a-row class="basic_row">
      <a-col :span="10" class="basic_title">专家在线审稿系统名称：</a-col>
      <a-col :span="14" class="basic_input">
        <a-input
          placeholder="请输入"
          class="input"
          v-model="basicInfo.expertSystemName"
        />
      </a-col>
    </a-row>
    <!-- <a-row class="basic_row">
      <a-col :span="10" class="basic_title">系统LOGO：</a-col>
      <a-col :span="14" class="basic_input">
        <a-upload
          name="file"
          :fileList="fileList"
          :action="uploadAddress"
          :headers="headers"
          @change="uploadFile"
          :remove="fileRemove"
          :data="data"
          accept=".png, .jpg"
        >
          <a-button>
            <a-icon type="upload" />选择图片
          </a-button>
        </a-upload>
        <img :src="logo" style="width:90px;height:90px;background-color: blue;margin-top:20px;" />
      </a-col>
    </a-row>
    <a-row class="basic_row">
      <a-col :span="10" class="basic_title">银行名称：</a-col>
      <a-col :span="14" class="basic_input">
        <a-input placeholder="请输入" class="input" v-model="basicInfo.bankName" />
      </a-col>
    </a-row>
    <a-row class="basic_row">
      <a-col :span="10" class="basic_title">账户名称：</a-col>
      <a-col :span="14" class="basic_input">
        <a-input placeholder="请输入" class="input" v-model="basicInfo.accountName" />
      </a-col>
    </a-row>
    <a-row class="basic_row">
      <a-col :span="10" class="basic_title">收款账户：</a-col>
      <a-col :span="14" class="basic_input">
        <a-input placeholder="请输入" class="input" v-model="basicInfo.account" />
      </a-col>
    </a-row> -->
    <a-row class="basic_row">
      <div align="center">
        <a-button type="primary" @click="submit">保存</a-button>
      </div>
    </a-row>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "basicInfo",
  data() {
    return {
      basicInfo: {},
      logo: "",
      serviceAddress: this.$config.serviceAddress,
      uploadAddress: this.$config.serviceAddress + "/file/uploadHeadPortrait",
      headers: {
        authorization: "authorization-text",
      },
      data: {
        fileType: "logo",
      },
      fileList: [],
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.axios
        .get("/basicInfo/queryBasicInfo", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.basicInfo = res.data.data;
            this.logo = this.serviceAddress + this.basicInfo.logoPath;
          } else {
            this.utils.messageInfo(this, "error", "查询系统基本信息失败！");
          }
        });
    },
    uploadFile(info) {
      this.fileList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
        if (this.fileList[0].response.code == "OK") {
          this.newPhoto =
            this.serviceAddress + this.fileList[0].response.data.filePath;
        }
      }
      if (info.file.status === "done") {
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove() {
      this.fileList = [];
    },
    submit() {
      var logoPath = "";
      if (this.fileList.length > 0) {
        if (this.fileList[0].response.code == "OK") {
          logoPath = this.fileList[0].response.data.filePath;
        }
      }

      this.axios
        .post("/basicInfo/saveBasicInfo", {
          editSystemName: this.basicInfo.editSystemName,
          authorSystemName: this.basicInfo.authorSystemName,
          expertSystemName: this.basicInfo.expertSystemName,
          logoPath: logoPath,
          bankName: this.basicInfo.bankName,
          accountName: this.basicInfo.accountName,
          account: this.basicInfo.account,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "保存成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "保存失败！");
          }
        });
    },
  },
};
</script>

<style scoped>
.basic_title {
  text-align: right;
  margin-top: 5px;
}
.basic_input {
  width: 222px;
}
.basic_row {
  margin-bottom: 30px;
}
</style>